import { useState } from "react";
import { HomeOutlined, HomeWorkOutlined, AssignmentIndOutlined, Person, EmailOutlined } from "@mui/icons-material";

export const Website = () => {
    // REAL PROPERTY STATES
    // property-type selection (Condominium, Commercial, Apartment, House, & Land)
    const [propertyTab, setPropertyTab] = useState(0);
    // bottom-app-bar selectoon (Rent Property, Buy Property, Sell Your Property, Be Our Agent, & Message Us)
    const [bottomAppBar, setBottomAppBar] = useState([
        {
            bId: 1,
            label: "Rent Property",
            icon: <HomeOutlined />,
            isSelected: true,
            valueNav: "property-rent",
        },
        {
            bId: 2,
            label: "Buy Property",
            icon: <HomeWorkOutlined />,
            isSelected: false,
            valueNav: "property-buy",
        },
        {
            bId: 3,
            label: "Sell Your Property",
            icon: <AssignmentIndOutlined />,
            isSelected: false,
            valueNav: "sell-your-property",
        },
        {
            bId: 4,
            label: "Be Our Agent",
            icon: <Person />,
            isSelected: false,
            valueNav: "be-our-agent",
        },
        {
            bId: 5,
            label: "Message us",
            icon: <EmailOutlined />,
            isSelected: false,
            valueNav: "message-us",
        },
    ]);
    // subtypes selection (for the values of subtypes of each Property Type )
    const [select, setSelect] = useState("");
    // location selector for filtering
    const [location, setLocation] = useState(0);
    // what is to be generated subtypes based the value of PropertyType
    const [filterSubType, setFilterSubType] = useState([]);

    // for api locations
    const [dataLocations, setDataLocations] = useState({
        provinces: [],
        cities: [],
        barangays: [],
    });
    // input data from users (input fields, photos, radio button etc....)
    const [inputData, setInputData] = useState({
        sellYourProperty: {
            companyId: "",
            userId: "",
            status: 0,
            lastName: { value: "", stat: false, msg: "Last Name is required!" },
            firstName: { value: "", stat: false, msg: "First Name is required!" },
            mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
            email: { value: "", stat: false, msg: "Invalid Email!" },
            ownerType: 2,
            offerType: 1,
            propertyType: "",
            subType: "",
            condominiumName: "",
            subdivisionName: "",
            buildingName: "",
            unitNoFloorNo: "",
            blockLotUnitFloorNo: "",
            bedroom: "",
            bathroom: "",
            floorArea: "",
            landSize: "",
            forClosure: 0,
            preSelling: 0,
            price: { value: "", stat: false, msg: "Price is required!"},
            monthly: { value: "", stat: false, msg: "Monthly price is required!"},
            yearly: { value: "", stat: false, msg: "Yearly price is required!"},
            showPrice: 0, 
            availableFrom: { value: "", stat: false, msg: "Available date is required!"}, 
            listingTitle: { value: "", stat: false, msg: "Listing title is required" },
            description: "",
            province: { value: "", stat: false, msg: "Province is required!" },
            city: { value: "", stat: false, msg: "City is required!" },
            barangay: { value: "", stat: false, msg: "Barangay is required!" },
            streetNumber: "",
            indoorFacilities: { value: [], stat: false, msg: "Select atleast 1 indoor facilities"},
            outdoorFacilities: { value: [], stat: false, msg: "Select atleast 1 outdoor facilities"},
            youtubeLink: { value: "", stat: false, msg: "Please enter a proper youtube link!" },
            // photos for displaying
            propertyCoverPhoto: { value: "", stat: false, msg: "Cover photo is required!", objectImg: "", b64Img: "" },
            morePhotos: { value: [], stat: false, msg: "More photos are required!", b64Imgs: [], imgProperties: [] },
            // photos for S3 and for db/backend
            photos: [],
            checkList: [],
            isAgreedToPay: { value: 0, stat: false, msg: "This agreement is required!" },
        },
        beOurAgent: {
            lastName: { value: "", stat: false, msg: "Last Name is required!" },
            firstName: { value: "", stat: false, msg: "First Name is required!" },
            mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
            email: { value: "", stat: false, msg: "Invalid Email!" },
            province: { value: "", stat: false, msg: "Province is required!" },
            city: { value: "", stat: false, msg: "City is required!" },
            barangay: { value: "", stat: false, msg: "Barangay is required!" },
            streetNumber: { value: "", stat: false, msg: "" },
            message: { value: "", stat: false, msg: "Message is required!" },
        },
        contactUs: {
            fullName: { value: "", stat: false, msg: "Full Name is required!" },
            email: { value: "", stat: false, msg: "Invalid Email!" },
            mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
            message: { value: "", stat: false, msg: "Message is required!" },
        },
    });
    // cleared inputs
    const dfltForms = {
        sellYourProperty: {
            companyId: "",
            userId: "",
            status: 0,
            lastName: { value: "", stat: false, msg: "Last Name is required!" },
            firstName: { value: "", stat: false, msg: "First Name is required!" },
            mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
            email: { value: "", stat: false, msg: "Invalid Email!" },
            ownerType: 2,
            offerType: 1,
            propertyType: "",
            subType: "",
            condominiumName: "",
            subdivisionName: "",
            buildingName: "",
            unitNoFloorNo: "",
            blockLotUnitFloorNo: "",
            bedroom: "",
            bathroom: "",
            floorArea: "",
            landSize: "",
            forClosure: 0,
            preSelling: 0,
            price: { value: "", stat: false, msg: "Price is required!"},
            monthly: { value: "", stat: false, msg: "Monthly price is required!"},
            yearly: { value: "", stat: false, msg: "Yearly price is required!"},
            showPrice: 0, 
            availableFrom: { value: "", stat: false, msg: "Available date is required!"}, 
            listingTitle: { value: "", stat: false, msg: "Listing title is required" },
            description: "",
            province: { value: "", stat: false, msg: "Province is required!" },
            city: { value: "", stat: false, msg: "City is required!" },
            barangay: { value: "", stat: false, msg: "Barangay is required!" },
            streetNumber: "",
            indoorFacilities: { value: [], stat: false, msg: "Select atleast 1 indoor facilities"},
            outdoorFacilities: { value: [], stat: false, msg: "Select atleast 1 outdoor facilities"},
            youtubeLink: { value: "", stat: false, msg: "Please enter a proper youtube link!" },
            // photos for displaying
            propertyCoverPhoto: { value: "", stat: false, msg: "Cover photo is required!", objectImg: "", b64Img: "" },
            morePhotos: { value: [], stat: false, msg: "More photos are required!", b64Imgs: [], imgProperties: [] },
            // photos for S3 and for db/backend
            photos: [],
            checkList: [],
            isAgreedToPay: { value: 0, stat: false, msg: "This agreement is required!" },
        },
        beOurAgent: {
            lastName: { value: "", stat: false, msg: "Last Name is required!" },
            firstName: { value: "", stat: false, msg: "First Name is required!" },
            mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
            email: { value: "", stat: false, msg: "Invalid Email!" },
            province: { value: "", stat: false, msg: "Province is required!" },
            city: { value: "", stat: false, msg: "City is required!" },
            barangay: { value: "", stat: false, msg: "Barangay is required!" },
            streetNumber: { value: "", stat: false, msg: "" },
            message: { value: "", stat: false, msg: "Message is required!" },
        },
        contactUs: {
            fullName: { value: "", stat: false, msg: "Full Name is required!" },
            email: { value: "", stat: false, msg: "Invalid Email!" },
            mobileNumber: { value: "", stat: false, msg: "Please enter a valid mobile number!" },
            message: { value: "", stat: false, msg: "Message is required!" },
        }
    } 
    // erros and validations state
    const [error, setError] = useState(true);
    // user data state when submitting, boaSnackBar for be our agent / cuSnackBar for contact us
    const [userData, setUserData] = useState({
        boaSnackBar: false,
        cuSnackBar: false,
        hasInvalidInputs: false,
        sellYourProperty: {},
        beOurAgent: {},
        contactUs: {},
        boaLoader: false,
        disabled: false,
    });
    // for image slides
    const [imgCarousel, setImgCarousel] = useState({
        imgLink: "",
        index: 0,
    });
    // for types of property and subtypes
    const [types, setTypes] = useState({
        tabPropertyTypes: [],
        searchSubType: [],
        checkListItems: [],
        indoorFacilities: [],
        outdoorFacilities: [],
        avlblePrprtyTypes: [],
        avlblePrprtySubTypes: [],
        typesLoader: false,
    });
    // for loader and infiniteScroll when getting the listing/data of company properties
    const [loader, setLoader] = useState(true);
    const [inftScroll, setinftScroll] = useState(true);
    // for last id state
    const [lastId, setLastId] = useState();
    // for company properties/lists api stored
    const [companyProperties, setCompanyProperties] = useState({
        companyList: [],
        companyTheme: {},
        companyView: {
            viewDetails: {},
            viewAttachments: [],
        },
    });
    // for company assets (i.e, button colors, pictures, bgcolor, etc.)
    // for modal confirmation
    const [confirmation, setConfirmation] = useState({
        sypConfirmation: false,
        boaConfirmation: false,
        cuConfirmation: false,
        isLoggedIn: false,
        redirecting: false,
        isIndoorFacOpen: false,
        indoorLoader: false,
        isOutdoorFacOpen: false,
        outdoorLoader: false,
    });
    // loader for send button
    const [loaderSending, setLoaderSending] = useState(false);
    // for theme/colors of the company websites
    const [loaderTheme, setLoaderTheme] = useState(true);
    const [settings, setSettings] = useState(false);
    // for infinite scroll, trying new implementation
    const [cooldown, setCooldown] = useState(false);
    const [hasMore, setHasMore] = useState(true); 
    const [isLoading, setIsLoading] = useState(false);
    // buyer inquiry states
    const [form, setForm] = useState({
        fullName: { value: '', stat: false },
        email: { value: '', stat: false },
        contactNo: { value: '', stat: false },
    })
    const [success, setSuccess] = useState(false);
    const [errSending, setErrSending] = useState(false);

    return {
        // REAL PROPERTY STATES
        propertyTab: { data: propertyTab, set: setPropertyTab },
        bottomAppBar: { data: bottomAppBar, set: setBottomAppBar },
        select: { data: select, set: setSelect },
        location: { data: location, set: setLocation },
        filterSubType: { data: filterSubType, set: setFilterSubType },
        dataLocations: { data: dataLocations, set: setDataLocations },
        inputData: { data: inputData, set: setInputData },
        error: { data: error, set: setError },
        userData: { data: userData, set: setUserData },
        imgCarousel: { data: imgCarousel, set: setImgCarousel },
        types: { data: types, set: setTypes },
        loader: { data: loader, set: setLoader },
        inftScroll: { data: inftScroll, set: setinftScroll },
        lastId: { data: lastId, set: setLastId },
        companyProperties: { data: companyProperties, set: setCompanyProperties },
        confirmation: { data: confirmation, set: setConfirmation },
        loaderSending: { data: loaderSending, set: setLoaderSending },
        loaderTheme: { data: loaderTheme, set: setLoaderTheme },
        settings: { data: settings, set: setSettings },
        dfltForms: { data: dfltForms },
        cooldown: { data: cooldown, set: setCooldown },
        hasMore: { data: hasMore, set: setHasMore },
        isLoading: { data: isLoading, set: setIsLoading },
        form: { data: form, set: setForm },
        success: { data: success, set: setSuccess },
        errSending: { data: errSending, set: setErrSending },
    };
};
